//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../CAM/CAM.CylindricalMillingBuilder.js";
import "../CAM/CAM.ThreadMillingCutParameters.js";
import "../CAM/CAM.OppositeDirection.js";
let d=[[[1,"CutParameters",0,"CAM.ThreadMillingCutParameters",1],[0,"MotionOutput",1,0],[1,"OppositeDirectionBuilder",0,"CAM.OppositeDirection",1],[0,"RetractOutputMode",1,0],[0,"SpringPasses",1,0]],[],[]];
SPLM.CAM.ThreadMillingBuilder = class extends SPLM.CAM.CylindricalMillingBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.ThreadMillingBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.ThreadMillingBuilder.MotionOutputTypes = Object.freeze({
    "MachineCycle" : "MachineCycle", "SingleMoves" : "SingleMoves"});

SPLM.CAM.ThreadMillingBuilder.RetractOutputModeType = Object.freeze({
    "ClearanceOnly" : "ClearanceOnly", "ClearanceInitial" : "ClearanceInitial", "Always" : "Always", "PostDriven" : "PostDriven"});

export default SPLM;